/**
 * Domain-specific badges that pull labels + tones from constants.
 */

import {
  CONFIDENCE_TONE,
  EXCEPTION_SEVERITY_TONE,
  RUN_STATUS_TONE,
  STANCE_LABELS,
  STANCE_TONE,
  THESIS_TONE,
} from "@/lib/constants";
import type {
  ConfidenceBand,
  ExceptionSeverity,
  ModelRunStatus,
  StanceLabel,
  ThesisStatus,
} from "@/lib/api/types";
import { Pill } from "./Pill";

export function StanceBadge({ label }: { label: StanceLabel }) {
  return <Pill tone={STANCE_TONE[label]}>{STANCE_LABELS[label]}</Pill>;
}

export function ConfidenceBadge({ band }: { band: ConfidenceBand }) {
  return <Pill tone={CONFIDENCE_TONE[band]}>{band}</Pill>;
}

export function ThesisBadge({ status }: { status: ThesisStatus }) {
  return <Pill tone={THESIS_TONE[status]}>{status}</Pill>;
}

export function RunStatusBadge({ status }: { status: ModelRunStatus }) {
  return <Pill tone={RUN_STATUS_TONE[status]}>{status}</Pill>;
}

export function ExceptionSeverityBadge({ severity }: { severity: ExceptionSeverity }) {
  return <Pill tone={EXCEPTION_SEVERITY_TONE[severity]}>{severity}</Pill>;
}

const RECOMMENDATION_TONE = {
  buy: "good",
  hold: "warn",
  sell: "bad",
} as const;

const RECOMMENDATION_LABEL = {
  buy: "Buy",
  hold: "Hold",
  sell: "Sell",
} as const;

export function RecommendationBadge({
  rec,
}: {
  rec: "buy" | "hold" | "sell" | null | undefined;
}) {
  if (!rec) return <Pill tone="muted">No view</Pill>;
  return <Pill tone={RECOMMENDATION_TONE[rec]}>{RECOMMENDATION_LABEL[rec]}</Pill>;
}
